module.exports = __webpack_public_path__ + "static/forbid.0294a8c0.svg";